import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import store from '../store';
import itemSelector from './selectors/item';
import { getDataType } from './types/index';
/**
 * @type {import("./types").runDataItemTemplateType}
 */

var runDataItemTemplate = function runDataItemTemplate(template, itemIdentifier, directDataItem, encodeReplacedValue) {
  if (template.indexOf('{') === -1) return template;
  var dataTypeDefinition = getDataType(itemIdentifier.dataType);
  var builtInPlaceholders = {
    delete: 'delete',
    deleting: 'deleting'
  };

  if (itemIdentifier) {
    if (itemIdentifier.id) {
      builtInPlaceholders['id'] = function () {
        return itemIdentifier.id;
      };
    } else {
      builtInPlaceholders['id'] = function (data) {
        return data[dataTypeDefinition.data.idKeyProp];
      };
    }
  }

  var placeholders = _objectSpread({}, builtInPlaceholders, dataTypeDefinition.placeholders);

  var dataItem = directDataItem || itemSelector(store.getState(), itemIdentifier);
  var output = template;
  Object.keys(placeholders).map(function (token) {
    if (output.indexOf('{' + token + '}') === -1) return;
    var replaceValue = null;

    if (typeof placeholders[token] === 'function') {
      try {
        replaceValue = placeholders[token](dataItem);
      } catch (err) {}
    } else if (typeof placeholders[token] === 'string') {
      replaceValue = placeholders[token];
    }

    if (replaceValue !== null) {
      output = output.split('{' + token + '}').join(encodeReplacedValue ? encodeURIComponent(replaceValue) : replaceValue);
    } else {
      output = output.split('{' + token + '}').join('');
    }
  });
  return output;
};

export default runDataItemTemplate;